import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from "../../../Sections/DirectiveEntry/Entries/ExecutionEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from "../../../Sections/FinancialReviewEntry";

const ExecutionEntryOnGoingDirective = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        manualEntryProps={{
          showProposalDiagnostic: true,
        }}
      />
    </>
  );
}

export default ExecutionEntryOnGoingDirective;
